import Button from '@mui/material/Button';
import { Modal } from '@nextui-org/react';
import Image from './image.jpeg';
import React, { useState } from "react";
export default function ScanQR(){
    const [visible,setVisible] = useState(false);
    const closeHandler = () => {
        setVisible(false);
        console.log("closed");
    };
    const handleScanQR=()=>{
        setVisible(true);
    }
    return(
        <div>
          <Button style={{ color: '#b11116', fontSize:"15px" }} fullWidth onClick={handleScanQR}><b>Scan QR</b></Button>
          <Modal
             closeButton
             blur
             aria-labelledby="modal-title"
             open={visible}
             onClose={closeHandler}
            >
             <Modal.Body>
              <img src="https://reliablekota.com/mission-vriksh/image.jpeg" ></img>
             </Modal.Body>
            </Modal>
        </div>
    )
}